(() => {
  const scheduled = new WeakSet();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            initialize(entry.target);
          }
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function initialize(el) {
    if (!el.isConnected || el.swiper) return;
    const ready = typeof window.swiperCheckAndLoad === 'function'
      ? window.swiperCheckAndLoad()
      : Promise.resolve();
    ready.then(() => {
      if (!el.isConnected || el.swiper || typeof window.Swiper === 'undefined') return;
      new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: false,
        loop: true,
        speed: parseInt(el.dataset.speed || '5000', 10),
        autoplay: { delay: 1, disableOnInteraction: false },
        allowTouchMove: true,
        grabCursor: true,
        freeMode: { enabled: false },
      });
      el.classList.remove('reviewSwiper--pending');
    }).catch(() => {});
  }

  function observe(root = document) {
    root.querySelectorAll('.reviewSwiper').forEach(el => {
      if (scheduled.has(el) || el.swiper) return;
      scheduled.add(el);
      if (observer) observer.observe(el);
      else initialize(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else observe();
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();

function scrollToTop(event) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
